module.exports = __webpack_public_path__ + "img/filter.2eed3d30.svg";